document.querySelectorAll('.post-cards').forEach((slider) => {
	const parentBlock = slider.closest('.acf-block');

	const nextControl = parentBlock ? parentBlock.querySelector('.swiper-control--next') : false;
	const prevControl = parentBlock ? parentBlock.querySelector('.swiper-control--prev') : false;

	new (window as Window).Swiper(slider, {
		slidesPerView: 1,
		loop: false,
		spaceBetween: 16,
		navigation:
			nextControl && prevControl
				? {
						nextEl: `#${nextControl.getAttribute('id')}`,
						prevEl: `#${prevControl.getAttribute('id')}`,
					}
				: false,
		breakpoints: {
			576: {
				spaceBetween: 40,
				slidesPerView: 2,
			},
			800: {
				spaceBetween: 40,
				slidesPerView: 3,
			},
		},
	});
});
